import { Flex, Skeleton } from "@chakra-ui/react";
import { ContaItemResponse } from "core/features/conta/typings";
import moment from "moment";
import { Row, Col } from "antd";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import ContentItem from "components/ContentItem/ContentItem";
import InputMoney from "components/Input/InputMoney";
import Field from "components/Input/Field/index";
import { Control } from "react-hook-form";
import { PagarMultiplasContasForm } from "core/features/conta/typings/index";
import { OperacaoEnum } from "core/resources/enums/conta";

interface DescricaoContaProps {
  item?: ContaItemResponse;
  control: Control<PagarMultiplasContasForm, any>;
  isLoading: boolean;
  index: number;
  operacao?: OperacaoEnum;
}

export default function DescricaoConta({
  item,
  control,
  isLoading,
  index,
  operacao,
}: DescricaoContaProps) {
  const { tenant } = useCurrentTenant();

  return (
    <>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={8} flexDirection="column">
          <ContentItem
            titulo="Descrição"
            descricao={item?.descricao ? item.descricao : "-"}
          />
        </Flex>
        <Flex as={Col} xs={8} flexDirection="column">
          <ContentItem
            titulo="Vencimento"
            descricao={
              item?.dataVencimento
                ? moment(item?.dataVencimento).format("DD/MM/YYYY")
                : "-"
            }
          />
        </Flex>

        {tenant.tipoTenantId === TipoTenantEnum.Condominio ? (
          <Flex as={Col} xs={8} flexDirection="column">
            <ContentItem
              titulo="Unidade"
              descricao={item?.unidade ? item?.unidade : "-"}
            />
          </Flex>
        ) : null}
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={8} flexDirection="column">
          {isLoading ? (
            <Skeleton mt={3} w="100%" h="50px" rounded={6} />
          ) : (
            <Field
              control={control}
              label="Multa"
              name={`contas.${index}.multa`}
              shouldUnregister
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="0"
                />
              )}
            />
          )}
        </Flex>
        <Flex as={Col} xs={8} flexDirection="column">
          {isLoading ? (
            <Skeleton mt={3} w="100%" h="50px" rounded={6} />
          ) : (
            <Field
              control={control}
              label="Juros"
              name={`contas.${index}.juros`}
              shouldUnregister
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                  placeholder="0"
                />
              )}
            />
          )}
        </Flex>

        {operacao === OperacaoEnum.Receita ? (
          <Flex as={Col} xs={6} flexDirection="column">
            {isLoading ? (
              <Skeleton mt={3} w="100%" h="50px" rounded={6} />
            ) : (
              <Field
                control={control}
                label="Taxa adicional"
                name={`contas.${index}.taxaAdicional`}
                shouldUnregister
                render={({ field, isInvalid }) => (
                  <InputMoney
                    isInvalid={isInvalid}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="0"
                  />
                )}
              />
            )}
          </Flex>
        ) : null}

        {operacao === OperacaoEnum.Receita ? (
          <Flex as={Col} xs={6} flexDirection="column">
            {isLoading ? (
              <Skeleton mt={3} w="100%" h="50px" rounded={6} />
            ) : (
              <Field
                control={control}
                label="Taxa de registro"
                name={`contas.${index}.taxaRegistro`}
                shouldUnregister
                render={({ field, isInvalid }) => (
                  <InputMoney
                    isInvalid={isInvalid}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="0"
                  />
                )}
              />
            )}
          </Flex>
        ) : null}
      </Flex>
    </>
  );
}
